import React, { useState,useEffect } from 'react';
import { BiSolidCoinStack } from 'react-icons/bi';
import './RequestCredit.css';
import { Button } from 'antd';
import { FaPlus } from 'react-icons/fa6';
import { FaMinus } from 'react-icons/fa6';
import { SupportingDocumentTokenHandler } from "../../../../Redux/Actions/user/SupportingDocumentsToken";
import { useDispatch } from 'react-redux';
const crossside = '/assets/ModalClose.svg';

const RequestCredit = ({ CreditOverlay,workspace_id,openRequestCredit }) => {
    let dispatch = useDispatch();
    const [count, setCount] = useState(50);
    const [data, setData] = useState(0);
    const [code, setCode] = useState(false);
    const handleIncrement = () => {
        setData(data + 1)
        setCode(true)
        setCount((prevCount) => {
            return  prevCount + 1;
        });
    };
    
    const handleDecrement = () => {
        if(data > 0){
        setData(data -1)
        setCode(true)
        setCount(count - 1 >= 0 ? count - 1 : 0);
    }
    };
    const handleChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        setCount(isNaN(newValue) ? 0 : newValue);
        setData(isNaN(newValue) ? 0 : newValue)
    };
    const handleUpdate = () => {
        dispatch(SupportingDocumentTokenHandler(workspace_id,count))
        setTimeout(() => {
            CreditOverlay();
            setCount(50)
            setCode(false)
            setData(0)
          }, 2000);
    };
    useEffect(() => {
        if (openRequestCredit) {
          setData(0); 
          setCount(50); 
        }
      }, [openRequestCredit]);
    
    return (
        <>
            <div className='top-credit-request'>
                {' '}
                <h3>Request Credits </h3>
                <img src={crossside} alt='' onClick={CreditOverlay} />
            </div>
            <div className='drawer-request-credit'>
                <div className='drawer-request-credit1'>
                    <BiSolidCoinStack className='coin-icon' />
                </div>
                <div className='drawer-request-credit-2'>
                    <h2>{count}</h2>
                    <h2> Credits</h2>
                </div>
            </div>
            <p className='request-credit-para'>
                Increase or decrease the number of credit packages you'd like to
                request. Each package contains 200 credits.
            </p>
            <div className='request-credit-content'>
                <div className='request-counter'>
                    <button title={"Please Text Box Value is Zero"} className="button_in_dec" onClick={handleDecrement}>
                        <FaMinus />
                    </button>
                    <span><input type='text'
                    
                        value={data}
                        defaultValue={0}
                        onChange={handleChange}
                        className='countdata' />
                    </span>
                    {/* <span>{count}</span> */}
                    <button className="button_in_dec" onClick={handleIncrement}>
                        <FaPlus />
                    </button>
                </div>
                <div className='btn-credit'>
                    <Button className='main-api' onClick={handleUpdate}>Request Credits</Button>
                </div>
            </div>
        </>
    );
};

export default RequestCredit;
